import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c5a9f74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6c5a9f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@6.11.0_webpack@5.105.2__lodash@4_bf267459c9562454f9ca3caf3f535b20/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a9f74",
  null
  
)

export default component.exports